/**
 * Tujuan sesudah login.
 *
 * Dua alasan ini ada:
 *  1. Middleware `auth` menyimpan halaman yang tadi dituju di `?redirect=`,
 *     supaya user kembali ke sana — bukan dibuang ke beranda.
 *  2. Fallback-nya `/dashboard`, BUKAN `/`. App ini juga di-mount di
 *     salestial.iziapp.id, dan di host itu `/` adalah landing page statis —
 *     jadi login yang mengarah ke `/` akan terlihat "keluar dari app".
 *
 * Nilai `redirect` datang dari URL, jadi diperiksa dulu: hanya path internal
 * (mulai `/`, bukan `//` atau `/\`) yang diterima — kalau tidak, ini jadi
 * celah open-redirect.
 */
export function tujuanLogin(redirect: unknown, bawaan = '/dashboard'): string {
  const v = Array.isArray(redirect) ? redirect[0] : redirect
  const s = typeof v === 'string' ? v.trim() : ''
  if (!s || !s.startsWith('/')) return bawaan
  if (s.startsWith('//') || s.startsWith('/\\')) return bawaan   // protocol-relative
  if (s === '/login' || s.startsWith('/login?')) return bawaan
  return s
}
